import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, eventsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, eventsActions);

export default slice.reducer;
